
exports.StringToLongLineItemTransformer = () => {
  return {
    convertToVersionOne: (number) => number.toString(),
    convertToVersionTwo: (string) => Number(string)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@abc/transformers/src/transformers/lineItem/number/index.js